import React, { useRef, useState } from "react";
import { FieldArray, Form, Formik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { openSnackbar } from "../../../../Redux/Actions/snackbarActions";
import SalesReturnService from "../../../../Service/Invoice/SalesReturn.service";
import FormControl from "../../../MUI_components/FormControl/fomikFormControl";
import customerService from "../../../../Service/Customer/customer.service";
import Steper from "../../../MUI_components/stepper";
import Print from "../Receipt/salesReturnBill/DotMatrix"
import PosPrint from "../Receipt/salesReturnBill/posBill"
import itemMasterService from "../../../../Service/Item-master/itemMaster.service";

import { currency } from "../../../MUI_components/currencyFormatterTag";
import { NumFormat } from "Components/MUI_components/currencyFormat";
import {
  Button,
  Checkbox,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { Delete } from "@mui/icons-material";
import Selects from "Components/MUI_components/AutoComplete/selects";
import { SALES_RETURN_TYPE } from "Components/Constants/SalesReturnType";
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";
import BasicDialog from "Components/MUI_components/Dialog-Box/basicDialog";
import { useReactToPrint } from "react-to-print";
import { pageStyle } from "Components/Print/printPagesStyles";
import { PAYMENT_STATUS_CODE } from "Components/Constants/PaymentStatusCode";

export default function ReturnWithoutBill(props) {
  const { setOpen, setSubmitted, parentCallback } = props;
  const dispatch = useDispatch();
  const stockLocations = useSelector((state) => state.location);
  const defaultLocationSelected = useSelector((state) => state.defaultLocation);
  const [disabledForSingle, setDisabledForSingle] = useState(false);
  const today = new Date().toISOString().split("T")[0];
  const [openBillPrint, setOpenBillPrint] = useState(false);
  const [cashPay, setCashPay] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submittedData, setSubmittedData] = useState("");
  const [returnedDiscount, setReturnedDiscount] = useState(0);
  const [send,setSend] = useState(false)

  const computerReceiptPrintComponent = React.useRef(null);
  const billReceiptPrintComponent = React.useRef(null);

  const printTypeRef = useRef("pos");

  const handlePrintPOS = useReactToPrint({

    content: () => billReceiptPrintComponent.current,
    onAfterPrint: () => {
      setOpenBillPrint(true);
      setOpen(false);
    },
    pageStyle: pageStyle.receipt,
  });

  const handlePrintDotMatrix = useReactToPrint({
    content: () => computerReceiptPrintComponent.current,
    onAfterPrint: (values) => {
      setOpenBillPrint(true);
      setOpen(false);

    },
    pageStyle: pageStyle.a4,
  });

  const handlePrint = () => {
    if (printTypeRef.current === "dot") {
      handlePrintDotMatrix();
    } else {
      handlePrintPOS();
    }
  }

  const initReturn = {
    customer: "",
    returnData: [],
    code: "",
    remarks: "",
    paidStatus: 0,
    itemMaster: null,
    quantity: "",
    totalAmount: "",
    locationCode: "",
    costPrice: "",
    retailPrice: "",
    wholesalePrice: "",
    batch: "",
    expiryDate: "",



  };

  const validation = yup.object({
    customer: yup.object().required("Customer is required"),
    returnData: yup.array().required(),
  });

  const [activeStep, setActiveStep] = React.useState(0);
  const [submitting, setSubmitting] = React.useState(false);

  const getSteps = ["Return without bill", "Returned items"];
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const sendDataToParent = (totalAmount,returnCode) => {
    parentCallback(totalAmount,returnCode);
  };

  const handleChecked = (e, target) => {
    setCashPay(target);
  };

  function roundToNearestTen(value) {
    let roundedValue;
    roundedValue = Math.round(parseFloat(value) / 10) * 10;
    return roundedValue;
}

  const handleSubmit = async (values) => {
    setDisabledForSingle(true);
    setSubmitting(true);
    try {
      let totalAmount = values.returnData
        .map((data) => data.totalAmount)
        .reduce((totalAmount, i) => totalAmount + i, 0);

      const res = await SalesReturnService.create({
        ...values,
        totalAmount: totalAmount,
        paidStatus:cashPay ? PAYMENT_STATUS_CODE.CASH_PAY : PAYMENT_STATUS_CODE.PAYMENT_NOT_DONE,
        send:send
      });
      setSubmittedData(res.submittedData)
      let returnCode = res.code;
      send && sendDataToParent(
        totalAmount,
        returnCode
      );

      //setSubmitted((prev) => !prev);
      dispatch(
        openSnackbar(true, "success", `Sales return added successfully`)
      );
      handlePrint();
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
    setSubmitting(false);
    setTimeout(() => {
      setDisabledForSingle(false);
    }, 10000); // 10 seconds  
  };

  return (

    <Grid container justify="center">
      <Grid item lg={12} sm={12} xs={12}>
        <Formik
          initialValues={initReturn}
          validationSchema={validation}
          onSubmit={async (values) => {
            let val = {
              ...values,
              totalAmount: initReturn.totalAmount,
              locationCode: defaultLocationSelected.location.code,
              customerCode: values.customer.code,
              returnType: SALES_RETURN_TYPE.SALES_RETURN_WITHOUT_BILL

            }
            if (activeStep === getSteps.length - 1) {
              handleSubmit(val);
            } else handleNext();
          }}
        >
          {(props) => {
            const { values } = props;
            let totalAmount = props.values.returnData
              .map((data) => data.totalAmount)
              .reduce((totalAmount, i) => totalAmount + i, 0);

            let val = {
              ...values,
              totalAmount: initReturn.totalAmount,
              locationCode: defaultLocationSelected.location.code,
              customerCode: values.customer.code,
              returnType: SALES_RETURN_TYPE.SALES_RETURN_WITHOUT_BILL

            }
            return (
              <Form autoComplete="off">
                <Steper
                  getSteps={getSteps}
                  StepContent={getStepContent}
                  activeStep={activeStep}
                  values={props.values}
                  setFieldValue={props.setFieldValue}
                />
                <div className="flex space-between mb">
                  <Button
                    disabled={activeStep === 0 || props.isValid === false}
                    onClick={handleBack}
                  >
                    Back
                  </Button>
                  <div style={{ display: "flex" }}>
                    {activeStep !== getSteps.length - 1 && (
                      <Button
                        startIcon={
                          submitting && (
                            <CircularProgress color="inherit" size={20} />
                          )
                        }
                        variant="contained"
                        type="submit"
                        color="secondary"
                      >
                        Next
                      </Button>
                    )}

                    {activeStep === getSteps.length - 1 && (
                      <Button
                        disabled={
                          disabledForSingle ||
                            submitting ||
                            (!props.values.returnData.length &&
                              activeStep === getSteps.length - 1)
                            ? true
                            : false
                        }
                        startIcon={
                          submitting && (
                            <CircularProgress color="inherit" size={20} />
                          )
                        }
                        variant="contained"
                        // type="submit"
                        onClick={() =>
                          setOpenBillPrint(true)
                        }
                        color="secondary"
                      >
                        Complete
                      </Button>
                    )}


                    <Button onClick={() => {
                      // sendDataToParent(totalAmount);
                      // handleSubmit(val);
                      // setOpen(false);
                      setOpenBillPrint(true)
                      setSend(true)
                    }}>{activeStep === getSteps.length - 1 ? "Apply" : ""} </Button>

                    <BasicDialog
                      title="Sales Return Without Bill"
                      open={openBillPrint}
                      onClose={(e) => setOpenBillPrint(false)}
                    >
                      {!send && (
                        <div>
                        <span>  <Checkbox
                          label='Cash Pay'
                          onChange={handleChecked}
                        />
                        </span>
                        <span style={{ color: 'red' }}>
                          CASH PAY
                        </span>

                      </div>
                      )}
                      
                      <div className="flex">
                        <button
                          disabled={disabledForSingle}
                          type="button"
                          className="btn-success button"
                          onClick={() => {
                            printTypeRef.current = "pos";
                            handleSubmit(val);

                          }}
                        >
                          pos bill
                          <span>
                            {loading ? (
                              <CircularProgress
                                color="inherit"
                                size={20}
                              />
                            ) : (
                              "[ Enter ]"
                            )}
                          </span>
                        </button>

                        <button
                          type="button"
                          disabled={disabledForSingle}
                          onClick={() => {
                            printTypeRef.current = "dot";
                            handleSubmit(val);
                          }}
                          className="btn-success button"
                        >
                          Dot matrix bill
                          <span>
                            {loading ? (
                              <CircularProgress
                                color="inherit"
                                size={20}
                              />
                            ) : (
                              ""
                            )}
                          </span>
                        </button>

                      </div>
                      <div className="flex-end">
                        <Button
                          color="secondary"
                          onClick={() => {
                            setOpenBillPrint(false)
                          }}
                        >
                          Close
                        </Button>
                      </div>
                    </BasicDialog>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </Grid>
    </Grid>
  );
  function getStepContent(step, values, setFieldValue) {


    switch (step) {
      case 0:
        return (
          <div className="flex mt">
            <div className="col-4">
              <FormControl
                control="asynchronousAutoComplete"
                label="Customer"
                name="customer"
                Service={customerService}
                getOptionLabel={(option) =>
                  option.firstName + " - " + option.secondName + " - " + option.customCode +
                  " - " +
                  option.phone1
                }
              />
            </div>
            <div className="col-7">
              <FormControl label="Remarks" name="remark" control="input" />
            </div>
          </div>
        );
      case 1:
        return (
          <FieldArray name="returnData">
            {(returnDataProps) => (
              <>
                <div className="row">
                  <div className="col-7">
                    <FormControl
                      control="asynchronousAutoComplete"
                      label="Item Master"
                      name="itemMaster"
                      Service={itemMasterService}
                      withoutLocationFilter
                      getOptionLabel={(option) => option.barcode + " - " + option.name}
                    />
                  </div>
                  <div className="col-5">
                    <Selects
                      disabled
                      label="Stock Location*"
                      options={stockLocations}
                      name="locationCode"
                      // value={stock.locationCode}
                      value={defaultLocationSelected.location.code}
                    />
                  </div>

                </div>
                <div className="row">

                  <div className="col-4">
                    <FormControl
                      fullWidth
                      label="Quantity"
                      control="number"
                      name="quantity"
                    />
                  </div>
                  <div className="col-4">
                    <FormControl
                      name="retailPrice"
                      label="Retail Price*"
                      control="currency"

                    />
                  </div>
                  <div className="col-4">
                    <FormControl
                      control="input"
                      type="date"
                      name="expiryDate"
                      label="Expiry Date"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    //  inputProps={{
                    //    min: today,
                    //  }}
                    />
                  </div>
                </div>

                <div className="flex flex-end mb">
                  <Button
                    variant="contained"
                    type="button"
                    disabled={!values.itemMaster || !values.quantity || !values.retailPrice}
                    color="primary"
                    onClick={() => {
                      const qty = values.quantity ? values.quantity : 1;
                      returnDataProps.push({
                        itemMaster: values.itemMaster,
                        itemCode: values.itemMaster.code,
                        customerCode: values.customer.code,
                        locationCode: defaultLocationSelected.location.code,
                        quantity: qty,
                        costPrice: values.costPrice,
                        retailPrice: roundToNearestTen(values.retailPrice),
                        totalAmount: roundToNearestTen(values.retailPrice) * qty,
                        batch: values.batch,
                        expiryDate: values.expiryDate,
                      });
                      setFieldValue("itemMaster", null);
                      setFieldValue("quantity", "");
                      setFieldValue("costPrice", "");
                      setFieldValue("wholesalePrice", "");
                      setFieldValue("retailPrice", "");
                      setFieldValue("batch", "");

                    }}
                  >
                    Add
                  </Button>
                </div>
                <div className="flex mt mb">
                  <TableContainer>
                    <Table size="small" aria-label="spanning table">
                      <TableHead style={{ backgroundColor: "#cacaca50" }}>
                        <TableRow>
                          <TableCell align="center" colSpan={4}>
                            Details
                          </TableCell>
                          <TableCell align="right">{COLUMNS_NAME.AMOUNT}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell width="5"></TableCell>
                          <TableCell>{COLUMNS_NAME.DESCRIPTION}</TableCell>
                          <TableCell align="right">{COLUMNS_NAME.QUANTITY}</TableCell>
                          <TableCell align="right">{COLUMNS_NAME.RETAIL_PRICE}</TableCell>
                          <TableCell align="right">{COLUMNS_NAME.TOTAL}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {values.returnData.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell width="5">
                              <Delete
                                color="secondary"
                                style={{
                                  fontSize: 18,
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  if (
                                    window.confirm(
                                      "Are you sure want to delete this?"
                                    )
                                  )
                                    returnDataProps.remove(index);
                                }}
                              />
                            </TableCell>
                            <TableCell>{row.itemMaster["name"]}</TableCell>
                            <TableCell align="right">
                              <FormControl
                                control="customInput"
                                name={`returnData[${index}].quantity`}
                              />
                            </TableCell>
                            <TableCell align="right">
                              <FormControl
                                control="customInput"
                                name={`returnData[${index}].retailPrice`}
                              />
                            </TableCell>
                            <TableCell align="right">
                              {currency(row.quantity * row.retailPrice)}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                      <TableHead>
                        {values.returnData.length === 0 ? (
                          <TableRow>
                            <TableCell align="center" colSpan={7}>
                              No Data
                            </TableCell>
                          </TableRow>
                        ) : (
                          <>
                            <TableRow>
                              <TableCell colSpan={3} />
                              <TableCell align="right">
                                <strong>{COLUMNS_NAME.TOTAL}</strong>
                              </TableCell>
                              <TableCell align="right">
                                <strong>{currency(values.returnData
                                  .map((data) => data.retailPrice * data.quantity)
                                  .reduce((totalAmount, i) => totalAmount + i, 0))}</strong>
                              </TableCell>
                            </TableRow>
                          </>
                        )}
                      </TableHead>
                    </Table>
                  </TableContainer>
                </div>
                <div style={{ display: "none" }}>
                  {submittedData.code && (
                    <>
                      <Print
                        // code={invoice.code ? invoice.code : null}
                        ref={computerReceiptPrintComponent}
                        submittedData={submittedData}
                        returnedDiscount={returnedDiscount}

                      />
                      <PosPrint
                        ref={billReceiptPrintComponent}
                        submittedData={submittedData}
                        returnedDiscount={returnedDiscount}
                      />
                    </>
                  )}
                </div>
              </>
            )}
          </FieldArray>
        );
      default:
        return null;
    }
  }
}